import Form from 'src/utils/Form'
const state = {
  roles: [],
  permissions: [],
  permissions_loading: false
};

const mutations = {
  'SET_ROLES'(state, arg) {
    state.roles = arg;
  },
  'SET_PERMISSIONS'(state, arg) {
    state.permissions = arg;
  },
  'SET_LOADING'(state, arg) {
    state.permissions_loading = arg;
  }
};

const actions = {
  async set_roles ({commit}) {
    try {
      let roles = await new Form().get('roles/list');
      commit('SET_ROLES', roles);
      return roles;
    } catch (e) {
      return e;
    }
  },
  async set_permissions ({commit}, role) {
    let permissions = [];
    try {
      commit('SET_LOADING', true);
      if(role) {
        permissions = await new Form().get('permissions/' + role);
      }
      commit('SET_PERMISSIONS', permissions);
      commit('SET_LOADING', false);
      return permissions;
    } catch (e) {
      commit('SET_LOADING', false);
      return e;
    }
  },
};

const getters = {
  permissions: state => {
    return state.permissions;
  },
  permissions_loading: state => {
    return state.permissions_loading;
  },
  roles: state => {
    return state.roles;
  },
};

export default {
  state,
  mutations,
  actions,
  getters
};
